export const download = (data, fileName) => {
    var fileURL = window.URL.createObjectURL(new Blob([data]));
    var fileLink = document.createElement('a');

    fileLink.href = fileURL;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);

    fileLink.click();
}

const fieldsWithNewFilesNumber = (array) => {
    let fieldFilesNumber = 0

    array.forEach(field => {
        let hasFiles = false

        field.value.files.forEach(file => {
            if (file.id === 0) {
                hasFiles = true
            }
        })

        if (hasFiles) {
            ++fieldFilesNumber
        }
    })

    return fieldFilesNumber
}

// AI generated function
export const createCSV = (array) => {
    if (!Array.isArray(array) || array.length === 0) {
        return '';
    }

    const cols = array.reduce((acc, obj) => {
        if (obj && typeof obj === 'object') {
            Object.keys(obj).forEach(k => {
                if (!acc.includes(k)) acc.push(k);
            });
        }
        return acc;
    }, []);

    const escapeCell = (value) => {
        if (value === null || value === undefined) return '';
        // If object or array, stringify
        let str = typeof value === 'object' ? JSON.stringify(value) : String(value);
        // escape double quotes and wrap in quotes if needed
        if (/[",\r\n]/.test(str)) {
            str = '"' + str.replace(/"/g, '""') + '"';
        }

        return str;
    }

    const header = cols.map(c => escapeCell(c)).join(',');
    const rows = array.map(row => cols.map(col => escapeCell(row ? row[col] : '')).join(',')).join('\r\n');

    return header + (rows ? '\r\n' + rows : '');
}

export default {
    download,
    fieldsWithNewFilesNumber,
    createCSV,
}
